import React from 'react';
import { FiArrowUpRight } from 'react-icons/fi';
import { SHOW_NEWSLETTER } from '../config';
import { formatSocialCtaDesc } from '../utils/socialLabels';

const TILES = [
  {
    href: '#newsletter',
    variant: 'pink',
    kicker: 'Stay in touch',
    title: 'Join the list',
    desc: 'Weekly updates on new books, merchandise, and friends.',
  },
  {
    href: '#amazon',
    variant: 'gold',
    kicker: 'Available now',
    title: 'Buy now',
    desc: 'Coloring book & story adventures — order today.',
  },
  {
    href: '#discover',
    variant: 'purple',
    kicker: 'Discover more',
    title: 'Stories & more',
    desc: 'Stories, cozy gear, and read-alongs.',
  },
  {
    href: '#social',
    variant: 'teal',
    kicker: 'Follow along',
    title: 'Social',
    desc: formatSocialCtaDesc(),
  },
];

const VISIBLE_TILES = SHOW_NEWSLETTER ? TILES : TILES.filter(tile => tile.href !== '#newsletter');

export default function CtaTiles() {
  return (
    <div className="cta-tiles">
      {VISIBLE_TILES.map(tile => (
        <a key={tile.href} href={tile.href} className={`cta-tile cta-tile--${tile.variant}`}>
          <span className="cta-tile__kicker">{tile.kicker}</span>
          <span className="cta-tile__title">{tile.title}</span>
          <span className="cta-tile__desc">{tile.desc}</span>
          <span className="cta-tile__icon" aria-hidden>
            <FiArrowUpRight size={22} />
          </span>
        </a>
      ))}
    </div>
  );
}
